import { useReselector } from '@/utils/sharedHooks'
import { useState } from 'react'
import { selectFederalEstimateByTaxQuarter } from '@/features/taxes/quarterly-tax-estimates/userTaxEstimates.selector'
import { Button, Image, Link, Text } from '@/ui'
import { useNavigate } from 'react-router-dom'
import useTaxPaymentInfoFlyout from '../TaxPaymentInfoFlyout'
import { TypographyStyles } from '@/styles'

// TODO: Migrate to V2 skipcq: JS-0099
import { QuarterlyTaxEstimateDetail } from '@/featuresV1/Admin/QuarterlyTaxEstimateDetails/quarterlyTaxEstimateDetails.slice'
import UpdateQuarterlyTaxEstimateModal from '@/featuresV1/Taxes/QuarterlyTaxEstimates/components/UpdateQuarterlyTaxEstimateModal'

export const FinishCalculateSafeHarbor = ({
  details,
}: {
  details?: QuarterlyTaxEstimateDetail | null
}) => {
  const navigate = useNavigate()

  const federalTaxEstimate = useReselector(
    selectFederalEstimateByTaxQuarter,
    `${details?.taxYear}-${details?.taxQuarter}`
  )

  const [estimateModalOpen, setEstimateModalOpen] = useState(false)
  const openFlyout = useTaxPaymentInfoFlyout({
    estimateId: federalTaxEstimate?.id,
    openQTEModal: () => setEstimateModalOpen(true),
  })

  return (
    <div className="space-y-6 flex flex-col items-center max-w-3xl mx-auto text-center">
      <Text variant={TypographyStyles.DISPLAY_SM}>You&apos;re done!</Text>

      <Text variant={TypographyStyles.BODY_MD}>
        Now you can either proceed to payment (we&apos;ll walk you through how
        to do this), or if you&apos;re not ready yet, you can go back to the
        Quarterly Tax Center.
      </Text>

      <Text variant={TypographyStyles.BODY_MD}>
        Made a mistake? Go back and{' '}
        <Link href="/taxes/quarterly/calculate-safe-harbor">edit</Link>
      </Text>

      <Image
        src="https://heard-images.s3.amazonaws.com/assets/calculator2.svg"
        alt="Calculator"
        className="h-[180px] w-[180px]"
      />

      <div className="flex flex-col justify-center gap-4">
        {federalTaxEstimate && (
          <Button className="w-full" onClick={() => openFlyout()}>
            Pay Now
          </Button>
        )}

        <Button
          className="w-full"
          variant="secondary"
          onClick={() => navigate('/taxes/quarterly')}
        >
          Return to Quarterly Taxes
        </Button>
      </div>

      {federalTaxEstimate && (
        <UpdateQuarterlyTaxEstimateModal
          open={estimateModalOpen}
          close={() => setEstimateModalOpen(false)}
          estimate={federalTaxEstimate}
        />
      )}
    </div>
  )
}
